import { OrderProvider } from './components/OrderContext';
import Layout from "./components/Layout";

function App() {
    return (
      
      <OrderProvider>
        <Layout/>
      </OrderProvider>
    )
}

export default App;
